import { PortalRolesAdminSettings } from '@features/portal-administration/components/PortalRolesAdminSettings'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { hasPermission } from '@features/rbac/permissions'

export const Route = createFileRoute('/_layout/admin/roles')({
    beforeLoad: async ({ context }) => {
        if (!hasPermission('roles.manage')) {
            throw redirect({ to: '/unauthorised' })
        }
    },
    component: RouteComponent,
})

function RouteComponent() {
    return <PortalRolesAdminSettings />
}
